import { DELETE } from "src/app/common/constants/app.constants"

export const LEVELS = {
  TSType: "TSType",
  L1: "l1",
  L2: "l2",
  L3: "l3",
  L4: "l4",
}

export const LEVEL_ID = {
  L1: "L1",
  L2: "L2",
  L3: "L3",
  L4: "L4",
  USERSTORY: "userStory",
  TSTYPE: "TSType"
}

export const FILTER_FIELDS = {
  TAGS: "tags",
  OWNING_TEAM: "owningTeam"
}

export const ACTION = {
  ADD: "Add",
  EDIT: "Edit",
  COPY: "Copy"
}

export const TEST_CASE_FILTER_OPTIONS = {
  ALL: 'all',
  REVIEWED: 'Reviewed'
};

export const TEST_CASE_FILTER_STATUS = {
  REVIEWED: 'Reviewed'
};

export const TEST_CASE_FILTER_STORAGE_KEY = 'testCaseFilter';

export const DIALOG_CONFIG = {
  SCENARIO_SELECTION: {
    WIDTH: '820px',
    PANEL_CLASS: 'test-scenario-selection-dialog',
    OPEN_DELAY: 1000
  }
};

export const FILTER_TIMING = {
  APPLY_DELAY: 100
};

export const FILTER_DIALOG_TEXT = {
  TITLE: 'Default Filtering Parameters',
  DESCRIPTION: 'Please select whether you want to view all test cases or only those marked as Reviewed:',
  ALL_OPTION_TEXT: 'All Test Cases',
  REVIEWED_OPTION_TEXT: 'Reviewed',
  ALL_DESCRIPTION: 'Apply the filter using all test cases',
  REVIEWED_DESCRIPTION: 'Apply the filter for the Reviewed filter set',
  CONFIRM_BUTTON: 'Confirm',
  CANCEL_BUTTON: 'Cancel'
};

export const TEST_CASE_TYPES = {
  INTEGRATION_TEST : 'Integration Test',
  UNIT_TEST : 'Unit Test',
}
export const TEST_DATA_TYPES = ['Text', 'Number', 'Date'];
export const MAX_LENGTH = {
  PROJECT_ID :7,
  CLIENT : 8,
  TAXONOMY:10,
}
export const DATA_SOURCE = {
  TEST_AI:1,
  ASCEND: 2,
}
export const ADD_TEST_CASE = "Add Test Case";
export const EDIT_TEST_CASE = "Edit Test Case";
export const DUPLICATE_TEST_CASE = "Duplicate Test Case";
export const EDIT_TEST_CASE_MSG = "After saving the edited Test Case, the data will change at all points of its use";
export const FROM_LIBRARY = "From Library";
export const IMPORT_FROM_LIBRARY = "Import From Library";
export const SELECT_APP_VERSION = "Select Application Version";
export const SELECT_TAXONOMY = "Select Taxonomy";
export const DISABLED_APPVERSION = "App version will be available shortly";
export const ADD_MEMBERS = "Add Members";
export const ADD_TEAM = "Add Team";
export const SEARCH = "Search test case";
export const CLEAR_SEARCH = "Clear search";
export const SEARCH_TEST_CASES = "Start typing test case name";
export const PROJECT_SEARCH_TEST_CASES_PLACEHOLDER = "Enter test case name or test case ID";
export const NO_RESULTS_FOUND = "No results found";
export const LINK_USER_STORIES_MSG = "The test case must be tied to at least one User Story. Please select the User Stories you want to link instead of the current one.";
export const TEST_CASE_SEARCH_KEY_NAME = "testCaseName";
export const UNMAPPED_TEST_CASE_WARNING_TOOLTIP = "The Test Scenario contains missing test cases. The test case level has been changed or removed from the taxonomy.";
export const UNMAPPED_TEST_CASE_WARNING = "The Test Case level has been changed or removed from the taxonomy. Test Scenario will be downloaded with the exclusion of this Test Case from the file.";
export const OWNER = 'owner'
export const SEARCH_BOT_NAME = "Search typing bots name";

export const TOOLTIP_TEXT = {
  START: 'Move to Start',
  UP: 'Move to Up',
  DOWN: 'Move to Down',
  END: 'Move to End',
  DELETE: 'Remove Test Case',
  MAPPING: 'Show position',
  MISSING_TEST_CASE: 'Missing Test Case',
  DELETE_TEST_CASE: 'Delete Test Case',
  SAVE_TO_PROJECT: 'Save to project',
}

export const GENAI_FEATURE = "GenAi";
export const CONTROLS_FEATURE = "Controls";
export const CONTROLS_ENABLED = 'ControlsEnabled';
export const AUDIO_VIDEO_FEATURE = "AudioVideo";

export enum PROJECT_MODULE {
  UNIT_TEST = "UnitTest_TC",
  INTEGRATION_TEST = "IntegrationTest_TC"
}

export const FILTER_KEYS = [
  "l1Name",
  "l2Name",
  "l3Name",
  "l4Name",
  "status",
  "type",
  "bot",
  "system",
  "jobProfile",
  "applicationSteps",
  "userStoryCoverage",
  "devObjectCoverage",
  "testCaseOwner",
  "userStory",
  "mapping",
  "owningTeam",
  "tags",
  "userStoryStatus"
];

export const AI_GENERATED = "AI Generated";

export const REGEX_REMOVE_SPECIAL_CHARACTERS = /[^a-zA-Z0-9(). ]/g;

export const SNACKBAR_MSG = {
  SAVE_BOT_DICTIONARY: 'Bot saved successfully',
  ERROR_SAVE_BOT_DICTIONARY: 'Error occurred while saving Bot',
  ERROR_GETTING_URL: 'Error occurred while getting Test Manager Url',
  ERROR_GETTING_TOSCA_URL: 'Error occurred while getting Tosca Url',
  ADD_BOT_DICTIONARY: 'Bot added successfully',
  ERROR_ADD_BOT_DICTIONARY: 'Error occurred while adding Bot',
  ERROR_DOWNLOAD_XAML: 'Error occurred while downloading Bot',
  ERROR_DOWNLOAD_SELENIUM: 'Error occurred while downloading SELENIUM',
  XAML_DOWNLOADL: 'XAML file downloaded successfully',
  AUTO_GENERATED_SUCCESS_TEXT: 'Bot steps generated successfully',
  ERROR_FILL_REQUIRED_FIELDS: 'Please fill all required fields before saving',
  ERROR_GENERATING_XAML: 'Error occurred while generating XAML',
  ERROR_GENERATING_UIPATH_TEST_MANAGER: 'Error occurred while generating UI Path Test Manager',
  ERROR_GENERATING_TOSCA_SCRIPT: 'Error occurred while generating Tosca Script',
  SYNC_TOSCA_CLOUD_SUCCESS: 'Data dictionary updated successfully from Tosca Cloud',
  SYNC_TOSCA_CLOUD_IN_SYNC: 'Bot is already in sync with Tosca Cloud. Nothing to update.',
  ERROR_SYNC_TOSCA_CLOUD: 'Error occurred while syncing with Tosca Cloud',
  ERROR_GENERATING_SELENIUM: 'Error occurred while generating SELENIUM',
  ERROR_GENERATING_STEPS: 'Error occured while generating Bot steps',
  ERROR_FETCHING_BOT_DICTIONARY: 'Error occurred while Fetching Bot',
  RE_LINK_USER_STORY: 'User Story successfully re-linked',
  UPLOAD_INITIATED: 'Upload of Tests has been successfully initiated',
  UPLOAD_FILE_ERROR: 'An unknown error occurred. Please refresh the page and try again.',
  SAVE_IMPORT_FROM_LIBRARY: 'Test Scenario has been imported from Library app version ',
  ERROR_EXPORT_BOT_DICTIONARY: 'Error occurred while exporting Bot',
  EXPORT_BOT_DICTIONARY: 'Bot exported successfully',
  SAVE_CHANGE_TAXONOMY: 'Taxonomy for the current project successfully saved as ',
  DELETE_TEST_CASE_SUCCESS: 'Test Case deleted successfully',
}

export const SNACKBAR_NO_TEST_CASE_MSG = "No Test case found, please create a new one.";
export const FILTERS_RESET_MSG = "Filters have been reset. Active User Stories are shown by default.";
export const SNACKBAR_PANEL_CLASS = "custom-snackbar-class";

export const BOT_EXECUTION_TEMPLATE_TYPE = [{ name: 'Add Data Manually', icon: 'assets/images/edit_template.svg', id: 'Add Data Manually' }, { name: 'Upload via Excel', icon: 'assets/images/upload-taxonomy.svg', id: 'Upload via Excel' }];
export const EXECUTION_SETTINGS = [
  {
    name: 'Do not generate video',
    icon: 'assets/images/videoDisabled.svg',
    id: 'enableVideo',
  },
  {
    name: 'Continue Execution even when iteration fails',
    icon: 'assets/images/continueExecution.svg',
    id: 'continueOnFail',
  },
];

export const ADD_DATA_MANUALLY = 'Add Data Manually';
export const UPLOAD_VIA_EXCEL = 'Upload via Excel';
export const BOT_EXECUTION_SELECTION = 'Bot Execution Type Selection';
export const EXECUTION_TABLE = 'Execution table';
export const EXECUTION_SETTINGS_SELECTION = 'Select Execution Settings';
export const AUTO_GENERATE_BUTTON_TOOL_TIP = 'First, specify the context of the error';
export const APPLICATION_STEPS_LABEL = 'Application steps';
export const AUTO_GEN_L4_LABEL = 'Auto Generate L4';
export const APPLICATION_STEPS_AUTO_GEN_LABEL = 'Application steps - Auto Generate';
export const TEST_CASES_AUTO_GEN_LABEL = 'Test Cases - Auto Generate';
